import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

interface ImageCardSkeletonProps {
  index?: number;
}

const ImageCardSkeleton: React.FC<ImageCardSkeletonProps> = ({ index = 0 }) => {
  return (
    <motion.div 
      className="group relative cursor-pointer transition-all duration-300 ease-in-out hover:scale-[1.02]"
      initial={{ opacity: 0 }}
      animate={{ 
        opacity: 1,
        transition: {
          duration: 0.3,
          delay: index * 0.02
        }
      }}
      style={{ 
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        willChange: 'transform',
        transformStyle: 'preserve-3d'
      }}
    >
      {/* Modern card with glass morphism effect */}
      <div className="relative bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border border-white/20 dark:border-gray-700/30 rounded-2xl overflow-hidden shadow-lg transition-all duration-300">
        {/* Image skeleton with aspect ratio */}
        <div className="relative aspect-square">
          <Skeleton className="w-full h-full rounded-t-2xl">
            {/* Subtle shimmer effect */}
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"
              animate={{
                x: ['-100%', '200%'],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
                delay: index * 0.1
              }}
            />
          </Skeleton>
        </div>
        
        {/* Bottom action bar - simplified */}
        <div className="p-3 border-t border-gray-200/50 dark:border-gray-700/50">
          <div className="flex items-center justify-between">
            <Skeleton className="h-8 w-8 rounded-lg" />
            <div className="flex gap-2">
              <Skeleton className="h-8 w-8 rounded-lg" />
              <Skeleton className="h-8 w-8 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ImageCardSkeleton;